import type { SVGProps } from 'react'
import * as React from 'react'

const pdfInvoice = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.9996 2H5.99991C5.4695 2 4.96082 2.21071 4.58576 2.58579C4.2107 2.96086 4 3.46957 4 4V20C4 20.5304 4.2107 21.0391 4.58576 21.4142C4.96082 21.7893 5.4695 22 5.99991 22H17.9994C18.5298 22 19.0385 21.7893 19.4135 21.4142C19.7886 21.0391 19.9993 20.5304 19.9993 20V8L13.9996 2Z"
      stroke="#1B1C1F"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M13.999 2V8H19.9988" stroke="#1B1C1F" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.9997 13H8" stroke="#1B1C1F" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.9997 17H8" stroke="#1B1C1F" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.99991 9H8.99996H8" stroke="#1B1C1F" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default pdfInvoice
